<template>
    <section class="d-none d-md-block" id="products">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="title text-center">Productos</h2>
                    <div class="row" v-if="isLoading">
                        <div class="col-12 text-center">
                            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <carousel v-if="!isLoading && products.length > 0"
                              :navigationEnabled="true" :paginationEnabled="false" :perPage=4 :centerMode="true"
                              :loop="false" navigationNextLabel="&#x276F;" navigationPrevLabel="&#x276E;">
                        <slide v-for="(product, index) in OrdenedProducts" :key="index">
                            <div class="ml-3 card card-product-small" style="width: 90%" @click="goToProduct(product)">
                                <div class="card-header text-center">
                                    <img class="img-product-card"
                                         :src="product['producto_imagen']['public_path']"
                                         :alt="product['producto_imagen']['alt']">
                                </div>
                                <div class="card-body text-center">
                                    <p class="card-title mt-3 product-title-card">{{ product.title }}</p>
                                </div>
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {Carousel, Slide} from 'vue-carousel';
import axios from 'axios';

export default {
    components: {
        Carousel, Slide
    },
    data() {
        return {
            products: [],
            productData: null,
            isLoading: true,
            headers: {  //  Header to use on axios request 
                Accept: "application/json",
                ApiKey: "99296b00807e5fe3931bdb0b7b48b32f",
                "Content-Type": "application/json",
                "x-api-key": "9c6334a7-8215-46ff-8ec9-f442cdc43cac"
            }
        }
    },
    watch: {
        $product_data: {
            handler: function (newValue) {
                if (newValue) {
                    this.productData = newValue;
                }
            },
            immediate: true
        },
    },
    mounted() {
        this.getProducts();
    },
    methods: {
        getProducts() {
            this.isLoading = true;
            let params = {
                jfilter: ''
            }
            axios.post(`/api/get-recommended-products`, params, {headers: this.headers})
                .then(res => {
                    this.products = res.data.data
                    this.isLoading = false;
                })
                .catch(error => {
                    console.error(error);
                    this.isLoading = false;
                });
        },
        goToProduct(data) {
            trackClick('search-product', data.slug);
            window.location.href = `/productos/${data.slug}`;
        }
    },
    computed: {
        OrdenedProducts() {
            this.products = this.products.sort((a, b) => a.order - b.order);
            return this.products.filter(a => a.cantidad_pagaras === this.productData.cantidad_pagaras || a.dinero_necesitas === this.productData.dinero_necesitas || a.tiempo_pagaras === this.productData.tiempo_pagaras)
        }
    }
}
</script>

<style lang="sass">
</style>